var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAuthGg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Verify-your-Account",
    transform: "translate(-40.000000, -658.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(41.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#666666",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "brands-and-logotypes-(1)",
    transform: "translate(12.000000, 12.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09375,13 C6.09375,11.711832 6.44866016,10.5051172 7.06524609,9.47187109 L7.06524609,5.08904297 L2.68241797,5.08904297 C0.94290625,7.34819922 -1.42108547e-14,10.1015078 -1.42108547e-14,13 C-1.42108547e-14,15.8984922 0.94290625,18.6518008 2.68241797,20.910957 L7.06524609,20.910957 L7.06524609,16.5281289 C6.44866016,15.4948828 6.09375,14.288168 6.09375,13 L6.09375,13 Z",
    id: "Path",
    fill: "#FBBD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19.90625 L9.953125,22.953125 L13,26 C15.898543,26 18.6518008,25.0570937 20.910957,23.317582 L20.910957,18.9394258 L16.5328008,18.9394258 C15.4905156,19.5582461 14.2787227,19.90625 13,19.90625 L13,19.90625 Z",
    id: "Path",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06524609,16.5281289 L2.68241797,20.910957 C3.02681641,21.3582383 3.40183594,21.7865781 3.80762891,22.1924219 C6.26300391,24.6477461 9.52757812,26 13,26 L13,19.90625 C10.4800312,19.90625 8.27140234,18.549375 7.06524609,16.5281289 Z",
    id: "Path",
    fill: "#31AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,13 C26,12.209082 25.9283984,11.4166914 25.787125,10.644918 L25.6728164,10.0203594 L13,10.0203594 L13,16.1141094 L19.1674844,16.1141094 C18.5685703,17.3054883 17.6477031,18.2774922 16.53275,18.9394766 L20.9109063,23.3176328 C21.3581875,22.9732344 21.7865273,22.5982148 22.1923711,22.1924219 C24.6477461,19.7369961 26,16.4724219 26,13 L26,13 Z",
    id: "Path",
    fill: "#3C79E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8834805,8.11651953 L18.4220664,8.65510547 L22.7310078,4.34621484 L22.1924219,3.80762891 C19.7370469,1.35225391 16.4724727,0 13,0 L9.953125,3.046875 L13,6.09375 C14.8446797,6.09375 16.5790117,6.81210156 17.8834805,8.11651953 Z",
    id: "Path",
    fill: "#CF2D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,6.09375 L13,0 C9.52757812,0 6.26300391,1.35225391 3.80757813,3.80757813 C3.40178516,4.21337109 3.02676563,4.64171094 2.68236719,5.08904297 L7.06519531,9.47187109 C8.27140234,7.450625 10.4800312,6.09375 13,6.09375 Z",
    id: "Path",
    fill: "#EB4132"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAuthGg);
export default __webpack_public_path__ + "static/media/icAuthGg.d6946a0e4418a75ee3e05fc1b233a265.svg";
export { ForwardRef as ReactComponent };